import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../redux/actions'
import autobind from 'react-autobind';
import RegisterHeader from './../components/Register/Header'
import { Redirect, withRouter } from 'react-router-dom';
import Alert from './../components/Errors/Alert'
import SubscriptionBoxList from './../components/Subscription/SubscriptionBoxList'

const getUniqueSubscription = function (subsForDomain)
{
    return subsForDomain.find(domain => domain.name.toLowerCase().includes("demo"))
}

class RegisterPaymentPlans extends PureComponent {

    constructor(props) {
        super(props);
        const { moduleOptions, subscriptions:propsSubs } = props
            , subscriptions = propsSubs ? propsSubs : !moduleOptions ? [] : moduleOptions.map(option => {
                const { active, domainId, domainName, subscriptionId } = option
                    , domainSubscriptionId = getUniqueSubscription(props.domainSubscriptions[domainId])._id
                return {
                    collapsed: !active,
                    domainId,
                    domainName,
                    subscriptionId: subscriptionId ? subscriptionId : domainSubscriptionId
                }
            })
        this.state = {
            subscriptions,
        };
        autobind(this)
    }

    componentDidMount() {
        this.props.resetRegistrationStep(3)
        document.title = "Register Payment Plans"
    }

    componentWillReceiveProps(props) {

        const { subscriptions, error, step3 } = props
            , newState = { error }
        if (step3)
            return this.props.history.push("/register/payment-info")

        if (!this.state.subscriptions.length && subscriptions && subscriptions.length) {
            newState.subscriptions = [...subscriptions]
        }
        this.setState(newState)
    }

    onNextButtonClick() {
        const { subscriptions } = this.state
        this.props.registerFlowStep3(subscriptions)
    }

    toggleCollapse(domainId) {
        this.setState({
            subscriptions: this.state.subscriptions.map(stateSub => {
                if (stateSub.domainId === domainId) {
                    return { ...stateSub, collapsed: !stateSub.collapsed }
                } else {
                    return stateSub
                }
            })
        })
    }

    render() {

        const { subscriptions, error } = this.state
            , { step1, step2, domainSubscriptions } = this.props

        if (!step1) {
            return <Redirect to="/register" />
        }
        if (!step2) {
            return <Redirect to="/register/contact-info" />
        }

        const domainSubscriptionsMarkup = subscriptions.map((stateSub, index) => {

            const { domainId, domainName, collapsed, subscriptionId } = stateSub
                , subsForDomain = [getUniqueSubscription(domainSubscriptions[domainId])]
            return <SubscriptionBoxList
                key={domainId}
                id={domainId}
                errorMessage={""}
                currentSubscriptionId={subscriptionId}
                subscriptions={subsForDomain}
                onConfirmUpgrade={() => {}}
                removeSelection={() => {}}
                onChoosePlanClick={() => {}}
                moduleName={domainName}
                collapsed={collapsed}
                toggleCollapse={this.toggleCollapse}
                register={false}
                showDisclaimer={index === (subscriptions.length - 1) ? true : false}
                first={0 === index} />;
        })

        return (
            <div>
                <RegisterHeader />
                <div className="main-content main-content--register container">
                    <div className="row">
                        <div className="col">
                            {domainSubscriptionsMarkup}
                            {error ? (<div className="form-group row d-flex justify-content-center">
                                        <div className="col-sm-6">
                                            <Alert message={error} />
                                        </div>
                                    </div>) : null}                            
                            <div className="d-flex justify-content-center">
                                <button className="btn btn-rounded btn-space btn-transparent btn-lg-lateral-space mr-3" onClick={() => this.props.history.goBack()}>Back</button>
                                <button className="btn btn-rounded btn-space btn-primary btn-lg-lateral-space" onClick={this.onNextButtonClick}>Next</button>
                            </div>
                        </div>
                    </div>
                </div >
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const { registerPaymentPlans: { domainSubscriptions }, registerFlow: { subscriptions, moduleOptions, error, step1, step2, step3 } } = state
        return { domainSubscriptions, subscriptions, moduleOptions, error, step1, step2, step3 }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps);
    }
)(withRouter(RegisterPaymentPlans))



// WEBPACK FOOTER //
// ./src/containers/RegisterPaymentPlans.js